import { useState, useEffect } from "react";

export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    // Get or set the start time in localStorage
    let startTime = localStorage.getItem('documentUploadStartTime');
    if (!startTime) {
      startTime = new Date().toISOString();
      localStorage.setItem('documentUploadStartTime', startTime);
    }

    const timer = setInterval(() => {
      const start = new Date(startTime).getTime();
      const now = new Date().getTime();
      const deadline = start + (24 * 60 * 60 * 1000); // 24 hours from start
      const remaining = deadline - now;

      if (remaining <= 0) {
        clearInterval(timer);
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      setTimeLeft({ hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="inline-flex items-center space-x-1 text-sm font-mono bg-orange-50 px-3 py-1.5 rounded-md shadow-sm">
      <div className="font-semibold text-orange-800">
        {String(timeLeft.hours).padStart(2, '0')}
      </div>
      <span className="text-orange-500">:</span>
      <div className="font-semibold text-orange-800">
        {String(timeLeft.minutes).padStart(2, '0')}
      </div>
      <span className="text-orange-500">:</span>
      <div className="font-semibold text-orange-800">
        {String(timeLeft.seconds).padStart(2, '0')}
      </div>
    </div>
  );
};